import React from "react";
import { TrendingUp, TrendingDown, Info } from "lucide-react";
import { Panel } from "./ui";

const TONE_META = {
  positive: { icon: TrendingUp, color: "text-emerald-600 bg-emerald-50" },
  negative: { icon: TrendingDown, color: "text-rose-600 bg-rose-50" },
  neutral: { icon: Info, color: "text-sky-600 bg-sky-50" },
};

const AutomaticInsights = ({ data, loading, error, onRetry }) => (
  <Panel
    eyebrow="תובנות"
    title="תובנות מהנתונים"
    subtitle="נוצר אוטומטית מהמגמות בטווח שנבחר"
    accent="emerald"
    loading={loading}
    error={error}
    onRetry={onRetry}
    empty={!loading && !error && (!data || data.length === 0)}
  >
    <ul className="space-y-2.5">
      {data?.map((insight) => {
        const meta = TONE_META[insight.tone] || TONE_META.neutral;
        const Icon = meta.icon;
        return (
          <li key={insight.id} className="flex items-start gap-2.5">
            <span className={`w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 ${meta.color}`}>
              <Icon className="w-3.5 h-3.5" />
            </span>
            <p className="text-xs text-gray-700 leading-relaxed pt-0.5">{insight.text}</p>
          </li>
        );
      })}
    </ul>
  </Panel>
);

export default AutomaticInsights;
